import {isInfoTag} from '../domain/Tag.model.ts';
import {useTenantContext} from '../../tenant/TenantContext';

const getTagClassName = (tag) => {
  if (tag.type === 'CombinableTag') return 'badge text-white';
  if (tag.type === 'ComercialTag') return 'badge bg-dark text-white';
  if (isInfoTag(tag)) return 'badge border border-primary text-primary';
  return 'badge border border-warning text-warning';
};

// El color de "oferta" es por tenant (promoColor): VeterLucus usa ambar porque el
// naranja de LeonVet no casa con sus verdes.
const getTagStyle = (tag, promoColor) => {
  if (tag.type === 'CombinableTag') return { backgroundColor: promoColor || '#f0541e' };
  return undefined;
};

export const TagListUI = ({ data }) => {
  const { tags } = data;
  const { promoColor } = useTenantContext();
  return (
    <div className="d-flex flex-row align-items-center gap-1 flex-wrap">
      {
        tags.map((tag, index) => (
            <span key={index}
                  className={getTagClassName(tag)}
                  style={getTagStyle(tag, promoColor)}>
              {tag.value}
            </span>
          )
        )
      }
    </div>
  );
};
